// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__28xBB","item":"PaymentsMobile_item__3rp_X","label":"PaymentsMobile_label__45BsI","amount":"PaymentsMobile_amount__1YxQK"};